import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue-demi';

export default /*#__PURE__*/_defineComponent({
  __name: 'AbSliderItem',
  setup(__props) {

const mounted = ref(false);

onMounted(() => {
  setTimeout(() => {
    mounted.value = true;
  }, 300);
});

return { __sfc: true,mounted }
}

})